import script from "./AdminUsefulLinksView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsefulLinksView.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsefulLinksView.vue?vue&type=style&index=0&id=9cf11038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cf11038"]])

export default __exports__